<template>
    <div>CTC CORPORATION</div>
</template>